import { apiClient } from "./ApiClient";

export const retrieveUserIdByUsernameApi = (username) =>
  apiClient.get(`/user-view/user/get-id/${username}`);

export const retrieveUserByIdApi = (id) =>
  apiClient.get(`/user-view/user/get-user/${id}`);

export const retrieveUsersApi = () =>
  apiClient.get(`/user-view/user-list`);

export const getCurrentUserApi  = () =>
  apiClient.get(`/user-view/users/me`);